import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeviceIconDirective } from './device-icon.directive';

import { ThemeColorDirective } from '../utils/theme/theme-color.directive';
import { BrowserIconDirective } from './browser-icon.directive';
import { CopyToClipboardDirective } from './copy-to-clipboard.directive';
import { CreditDirective } from './credit.directive';
import { CursorPointerDirective } from './cursor-pointer.directive';
import { FailureCodeIconDirective } from './failure-code.directive';
import { ImageViewerDirective } from './image-viewer.directive';
import { LocalizedNumericInputDirective } from './input-number-seperator.directive';
import { JsonFormatterDirective } from './json-formatter.directive';
import { MediaFileTypeDirective } from './media-file-type.directive';
import { MediaStatusDirective } from './media-status.directive';
import { MobileOperatorImgDirective } from './mobile-operator-img.directive';
import { NumberTypeDirective } from './number-type.directive';
import { NumbersSeparatorDirective } from './numbers-separator.directive';
import { OnlyNumberDirective } from './only-number.directive';
import { OpenLinkDirective } from './open-link.directive';
import { OtpStatusDirective } from './otp-status.directive';
import { OutBoxStatusIconDirective } from './outBox-status-icon.directive';
import { OutBoxStatusDirective } from './outBox-status.directive';
import { PaymentStatusDirective } from './payment-status.directive';
import { PaymentTypeDirective } from './payment-type.directive';
import { PhonebookFileProgressStatusIconDirective } from './phonebook-file-progress-status-icon.directive';
import { PlatformIconDirective } from './platform-icon.directive';
import { ProgressPercentIconDirective } from './progress-percent-icon.directive';
import { QueueStatusIconDirective } from './queue-status-icon.directive';
import { QueueStatusDirective } from './queue-status.directive';
import { SendSubTypesDirective } from './send-sub-type.directive';
import { SendTypeIconLargeDirective } from './send-type-icon-large.directive';
import { SendTypeIconDirective } from './send-type-icon.directive';
import { SendTypeDirective } from './send-type.directive';
import { SmartCampainSmsRequestStatusDirective } from './smart-sms-campain-request-status.directive';
import { SmartSmsRequestIdDirective } from './smart-sms-request-id.directive';
import { SmartSmsRequestStatusDirective } from './smart-sms-request-status.directive';
import { SmsSenderAgentDirective } from './sms-sender-agent.directive';
import { SocialMediaFileDirective } from './social-media-file.directive';
import { UrlTypeIconDirective } from './social-media-icon.directive';
import { TransactionTypeIconDirective } from './transaction-type-icon.directive';
import { SmartSmsFileProgressStatusIconDirective } from './smart-sms-file-progress-status-icon.directive';
import { FrequencyStatusDirective } from './frequency-status.directive';
import { MatSelectInfiniteScrollDirective } from './mat-select-infinite-scroll.directive';
import { FieldTypeIconDirective } from './field-type-icon.directive';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OnlyNumberDirective,
    CopyToClipboardDirective,
    NumbersSeparatorDirective,
    LocalizedNumericInputDirective,
    JsonFormatterDirective,
    CursorPointerDirective,
    SendTypeDirective,
    OutBoxStatusDirective,
    OutBoxStatusIconDirective,
    QueueStatusIconDirective,
    QueueStatusDirective,
    SendSubTypesDirective,
    PaymentStatusDirective,
    PaymentTypeDirective,
    SendTypeIconDirective,
    SendTypeIconLargeDirective,
    FailureCodeIconDirective,
    BrowserIconDirective,
    PlatformIconDirective,
    DeviceIconDirective,
    TransactionTypeIconDirective,
    CreditDirective,
    SmsSenderAgentDirective,
    OtpStatusDirective,
    NumberTypeDirective,
    MobileOperatorImgDirective,
    SmartSmsRequestStatusDirective,
    SmartCampainSmsRequestStatusDirective,
    SmartSmsRequestIdDirective,
    UrlTypeIconDirective,
    OpenLinkDirective,
    PhonebookFileProgressStatusIconDirective,
    ProgressPercentIconDirective,
    MediaStatusDirective,
    MediaFileTypeDirective,
    SocialMediaFileDirective,
    ThemeColorDirective,
    ImageViewerDirective,
    SmartSmsFileProgressStatusIconDirective,
    FrequencyStatusDirective,
    MatSelectInfiniteScrollDirective,
    FieldTypeIconDirective,
  ],
  exports: [
    OnlyNumberDirective,
    CopyToClipboardDirective,
    NumbersSeparatorDirective,
    LocalizedNumericInputDirective,
    JsonFormatterDirective,
    CursorPointerDirective,
    SendTypeDirective,
    OutBoxStatusDirective,
    OutBoxStatusIconDirective,
    QueueStatusIconDirective,
    QueueStatusDirective,
    SendSubTypesDirective,
    PaymentStatusDirective,
    PaymentTypeDirective,
    SendTypeIconDirective,
    SendTypeIconLargeDirective,
    FailureCodeIconDirective,
    BrowserIconDirective,
    PlatformIconDirective,
    DeviceIconDirective,
    TransactionTypeIconDirective,
    CreditDirective,
    SmsSenderAgentDirective,
    OtpStatusDirective,
    NumberTypeDirective,
    MobileOperatorImgDirective,
    SmartSmsRequestStatusDirective,
    SmartCampainSmsRequestStatusDirective,
    SmartSmsRequestIdDirective,
    UrlTypeIconDirective,
    OpenLinkDirective,
    PhonebookFileProgressStatusIconDirective,
    ProgressPercentIconDirective,
    MediaStatusDirective,
    MediaFileTypeDirective,
    SocialMediaFileDirective,
    ThemeColorDirective,
    ImageViewerDirective,
    SmartSmsFileProgressStatusIconDirective,
    FrequencyStatusDirective,
    MatSelectInfiniteScrollDirective,
    FieldTypeIconDirective,
  ],
  providers: [DecimalPipe],
})
export class ShareDirectivesModule {}
